import classNames from "classnames";
import { AccountSearchResult } from "../../../lib/api/models";
import Table from "../../common/tables/Table";
import { TableColumn } from "../../common/tables/Table/Table";
import styles from "./AccountSearchResultsTable.module.css";
import { convertDateStringToMonthDayYearFormat } from "../../../lib/formatting";

const strings = {
  nameOnCard: "Name on Card",
  billingAddress: "Billing Address",
  card: "Card",
  last4CardNumber: "Last 4 Card #",
  last4SSN: "Last 4 SSN",
  dateOfBirth: "DOB",
  status: "Status",
  credit: "Credit",
};

type Props = {
  accounts: AccountSearchResult[];
  onClickAccount: (acc: AccountSearchResult) => void;
  className?: string;
};

export default function AccountSearchResultsTable({
  accounts,
  onClickAccount,
  className,
}: Props) {
  const columns: TableColumn<AccountSearchResult>[] = [
    {
      header: strings.nameOnCard,
      size: 3,
      alignment: "left",
      render: (row) => <span>{row.name}</span>,
    },
    {
      header: strings.billingAddress,
      size: 3,
      alignment: "left",
      render: (row) => <span>{row.address}</span>,
    },
    {
      header: strings.card,
      size: 2,
      alignment: "left",
      render: () => <span>{strings.credit}</span>,
    },
    {
      header: strings.last4CardNumber,
      size: 2,
      alignment: "left",
      render: (row) => <span>{row.cardNumberLast4}</span>,
    },
    {
      header: strings.last4SSN,
      size: 2,
      alignment: "left",
      render: (row) => <span>{row.ssnLast4}</span>,
    },
    {
      header: strings.dateOfBirth,
      size: 2,
      alignment: "left",
      render: (row) => (
        <span>{convertDateStringToMonthDayYearFormat(row.birthDate)}</span>
      ),
    },
    {
      header: strings.status,
      size: 3,
      alignment: "left",
      render: (row) => (
        <span>{`${row.externalStatus} / ${row.internalStatus}`}</span>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      data={accounts}
      className={classNames(styles.table, className)}
      onClickRow={onClickAccount}
    />
  );
}
